import { render, staticRenderFns } from "./FormulaEditTextarea.vue?vue&type=template&id=3fa29e71"
import script from "./FormulaEditTextarea.vue?vue&type=script&lang=js"
export * from "./FormulaEditTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports